import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Banner',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Banner',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Banner',
    column_type: 'datetime',
  },
  target: {
    model_name: 'Banner',
    column_type: 'string',
  },
  position: {
    model_name: 'Banner',
    column_type: 'integer',
  },
  page_position: {
    model_name: 'Banner',
    column_type: 'enum',
  },
  kind: {
    model_name: 'Banner',
    column_type: 'enum',
  },
  alt: {
    model_name: 'Banner',
    column_type: 'string',
  },
  image: {
    model_name: 'Banner',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
